import React from "react";
import "./HomePage.scss";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

const features = [
  {
    icon: <i className="bi bi-tools icon" style={{color: "#E14504", fontSize: "20px"}}></i>,
    title: "Multi-brand Support",
    desc: "From Maruti to Mercedes, we handle all brands."
  },

  {
    icon: <i className="bi bi-shield-check icon" style={{color: "#E14504", fontSize: "20px"}}></i>,
    title: "Genuine Parts Guarantee",
    desc: "Only OEM-recommended parts used."
  },

  {
    icon: <i className="bi bi-cash-coin icon" style={{color: "#E14504", fontSize: "20px"}}></i>,
    title: "Transparent Pricing",
    desc: "No hidden costs — what you see is what you pay."
  },

  {
    icon: <i className="fa fa-handshake icon" style={{color: "#E14504", fontSize: "20px"}}></i>,
    title: "Trusted Partner Garages",
    desc: "Verified workshops with trained professionals."
  },

  {
    icon: <i className="bi bi-clock-history icon" style={{color: "#E14504", fontSize: "20px"}}></i>,
    title: "Real-Time Updates",
    desc: "Track your service every step of the way."
  }
  
];


const ChooseUs = () => {

  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  return (
    <div className="why-choose-us">
      {/* Load Karbon font only for this component */}
     

      <div className="image-container">
        {autoServicesBranding ?
      <>
         <img
          src="https://media.istockphoto.com/id/1347150429/photo/professional-mechanic-working-on-the-engine-of-the-car-in-the-garage.jpg?s=612x612&w=0&k=20&c=5zlDGgLNNaWsp_jq_L1AsGT85wrzpdl3kVH-75S-zTU="
          alt="Auto Services workshop"
          className="garage-image"
        />
      
      </>:<>
      <img
          src="https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/Eurorepar-car-service+1.png"
          alt="Euro Repar Garage"
          className="garage-image"
        />
      
      </>  
      }
      
      </div>

      <div className="content">
        <p className="karbon-heading">Why Choose Us</p>
        <div className="features">
          {features.map((item, idx) => (
            <div className="feature-box" key={idx}>
              <div className="icon-box">{item.icon}</div>
              <div className="text">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
